/**
 * Gate for the in-call "switch to video" / voice-to-video upgrade.
 *
 * Product decision: the live in-call upgrade path is broken (it gets stuck on
 * "Connecting video…"), so instead of attempting the upgrade we intercept the
 * button on ALL platforms and explain how to video call. Fresh/native video
 * CALLS still work — only the mid-call upgrade is gated behind this dialog.
 */
export function VideoUpgradeUnavailableDialog({
  open,
  onClose,
}: {
  open: boolean
  onClose: () => void
}) {
  if (!open) return null
  return (
    <div
      className="fixed inset-0 z-[70] flex items-center justify-center bg-black/60 p-4 backdrop-blur-sm"
      role="dialog"
      aria-modal="true"
      aria-labelledby="video-upgrade-title"
    >
      <div className="w-full max-w-sm rounded-2xl bg-white p-6 text-center text-slate-900 shadow-2xl">
        <h3 id="video-upgrade-title" className="text-lg font-bold">
          Switching to video is under development
        </h3>
        <p className="mt-2 text-sm text-slate-600">
          To video call, please hang up and start a new video call.
        </p>
        <button
          type="button"
          onClick={onClose}
          className="mt-5 w-full rounded-xl bg-brand-600 px-4 py-2.5 text-sm font-semibold text-white transition hover:bg-brand-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-400"
          autoFocus
        >
          Got it
        </button>
      </div>
    </div>
  )
}
